import { GetDecimalPlaces } from "./types";

export const getDecimalPlaces: GetDecimalPlaces = (stepVal) => {
  const decimalPart = stepVal.toString().split(".")[1];
  return decimalPart ? decimalPart.length : 0;
};
